import {connect} from 'react-redux';
import {denormalize} from 'normalizr';

import {schema} from '../../../../../state/schema';
import {loadPlannerToDosSuggested, deletePlannerToDoSuggested} from '../../../../../state/modules/plannerToDosSuggested/actions';
import {sendMessage} from '../../../../../state/actions';
import PlannerToDosSuggestedList from '../components/PlannerToDosSuggestedList';

const mapStateToProps = (state, ownProps) => {

  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;
  const result = state.plannerToDosSuggested.getIn(['pages', order, limit, page]);

  return {
    list: result 
      ? result.map(x => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['plannerToDosSuggested', x]),
              schema.plannerToDoSuggested,
              state.entities.toJS()
            )
          };
        }).toArray()
      : [],
    isLoading: state.plannerToDosSuggested.get('isLoading'),
    total: state.plannerToDosSuggested.get('total'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    load: (page, limit, order, filter, cb) => {
      dispatch(loadPlannerToDosSuggested(page, limit, order, filter, cb));
    },
    remove: (id, cb) => {
      dispatch(deletePlannerToDoSuggested(id, cb));
    },
    sendMessage: (level, title, body, expires) => {
      dispatch(sendMessage(level, title, body, expires));
    },
  }
}

const PlannerToDosSuggestedListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PlannerToDosSuggestedList);

export default PlannerToDosSuggestedListContainer;